<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { StageSearch } from '@/api/games/stage';


export default {
    name: "stage-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: StageSearch,
        }
    }
}
</script>